//#region src/locales/en/common.json
var e = "Text alternative", t = "Font background color", n = "Bold", r = "Bulleted list", i = "Caption", a = "Decrease indent", o = "Default", s = "Paragraph spacing", c = "Font color", l = {
	adaptive: "Adaptive",
	adaptive_hint: "Ideal for a modern newsletter look. It uses a prioritized list of fonts (e.g., SF Pro, Roboto) and applies the first one available on the recipient's device",
	default: "Default",
	default_hint: "Uses the font set at the place of usage",
	hint: "Standard font uses email client fonts",
	mailbox_default: "Mailbox Default",
	mailbox_default_hint: "Ideal for a native inbox experience. Your message uses the default font of the recipient's email app (e.g., Gmail or Outlook), so it looks natural and blends into the inbox",
	title: "Font family"
}, u = "Font size", d = {
	apply: "Apply",
	clear: "Clear",
	error: "Error",
	more_options: "More options"
}, f = "Image", p = "Centered image", m = "Change image text alternative", h = "Change image caption", g = "Change image link", _ = "Set the image width to the full width of the mobile device", v = "Failed to process the image", y = "In line", b = "Insert after", x = "Insert before", S = "Insert image via link", C = "Side image", w = "Image via link", T = "Increase indent", E = { url: {
	mail: "Mail",
	site: "Site",
	tel: "Tel"
} }, D = "Italic", O = "Line height", k = "Link", A = "Numbered list", j = "Redo", M = {
	austral: "Austral sign",
	bitcoin: "Bitcoin sign",
	cedi: "Cedi sign",
	cent: "Cent sign",
	colon: "Colon sign",
	copyright_sign: "Copyright sign",
	cruzeiro: "Cruzeiro sign",
	currency: "Currency sign",
	dollar: "Dollar sign",
	dong: "Dong sign",
	double_dagger: "Double dagger",
	double_exclamation_mark: "Double exclamation mark",
	double_low_quotation_mark: "Double low-9 quotation mark",
	double_question_mark: "Double question mark",
	drachma: "Drachma sign",
	euro: "Euro sign",
	euro_currency: "Euro-currency sign",
	exclamation_question_mark: "Exclamation question mark",
	french_franc: "French franc sign",
	german_penny: "German penny sign",
	guarani: "Guarani sign",
	horizontal_ellipsis: "Horizontal ellipsis",
	hryvnia: "Hryvnia sign",
	indian_rupee: "Indian rupee sign",
	inverted_exclamation_mark: "Inverted exclamation mark",
	inverted_question_mark: "Inverted question mark",
	kip: "Kip sign",
	left_double_quotation_mark: "Left double quotation mark",
	left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark",
	left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark",
	left_single_quotation_mark: "Left single quotation mark",
	lira: "Lira sign",
	livre_tournois: "Livre tournois sign",
	manat: "Manat sign",
	mill: "Mill sign",
	new_sheqel: "New sheqel sign",
	nordic_mark: "Nordic mark sign",
	paragraph_sign: "Paragraph sign",
	per_mille_sign: "Per mille sign",
	per_ten_thousand_sign: "Per ten thousand sign",
	peseta: "Peseta sign",
	peso: "Peso sign",
	pound: "Pound sign",
	question_exclamation_mark: "Question exclamation mark",
	registered_sign: "Registered sign",
	reversed_paragraph_sign: "Reversed paragraph sign",
	right_double_quotation_mark: "Right double quotation mark",
	right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark",
	right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark",
	right_single_quotation_mark: "Right single quotation mark",
	ruble: "Ruble sign",
	rupee: "Rupee sign",
	section_sign: "Section sign",
	select_all: "All",
	select_currency: "Currency",
	select_text: "Text",
	single_low_quotation_mark: "Single low-9 quotation mark",
	spesmilo: "Spesmilo sign",
	tenge: "Tenge sign",
	title: "Special characters",
	trade_mark_sign: "Trade mark sign",
	tugrik: "Tugrik sign",
	turkish_lira: "Turkish lira sign",
	two_dot_leader: "Two dot leader",
	won: "Won sign",
	yen: "Yen sign"
}, N = "Strikethrough", P = "Substitute variables", F = "Substitutions", I = "Text alignment", L = {
	header_one: "Header 1",
	header_three: "Header 3",
	header_two: "Header 2",
	paragraph: "Paragraph",
	title: "Heading"
}, R = "Underline", z = "Undo", B = "Unset", V = {
	alt_text: e,
	background_color: t,
	bold: n,
	bulletList: r,
	caption: i,
	decrease_intent: a,
	default_font_size: o,
	extra_spacing: s,
	font_color: c,
	font_family: l,
	font_size: u,
	global: d,
	image: f,
	image_center: p,
	image_change_alt_text: m,
	image_change_caption: h,
	image_change_link: g,
	image_change_mobile_full_width: _,
	image_error: v,
	image_in_line: y,
	image_insert_after: b,
	image_insert_before: x,
	image_insert_via_link: S,
	image_side: C,
	image_via_link: w,
	increase_intent: T,
	input: E,
	italic: D,
	line_height: O,
	link: k,
	orderedList: A,
	redo: j,
	special_characters: M,
	strike: N,
	substitute_variables: P,
	substitutions: F,
	text_align: I,
	text_level: L,
	underline: R,
	undo: z,
	unset: B
};
//#endregion
export { e as alt_text, t as background_color, n as bold, r as bulletList, i as caption, a as decrease_intent, V as default, o as default_font_size, s as extra_spacing, c as font_color, l as font_family, u as font_size, d as global, f as image, p as image_center, m as image_change_alt_text, h as image_change_caption, g as image_change_link, _ as image_change_mobile_full_width, v as image_error, y as image_in_line, b as image_insert_after, x as image_insert_before, S as image_insert_via_link, C as image_side, w as image_via_link, T as increase_intent, E as input, D as italic, O as line_height, k as link, A as orderedList, j as redo, M as special_characters, N as strike, P as substitute_variables, F as substitutions, I as text_align, L as text_level, R as underline, z as undo, B as unset };
